import api from './BaseApi';

export const createAdmin = async (data) => {
    try {
        const response = await api.post('/admin/manage-admins', data);
        return response;
    } catch (error) {
        console.error('Create Admin error:', error);
        return error;
    }
};

export const getAdmins = async (params) => {
    try {
        const response = await api.get('/admin/manage-admins', { params });
        return response.data;
    } catch (error) {
        console.error('Get admins error:', error);
    }
};

export const updateAdmin = async (id, payload) => {
    try {
        const response = await api.put(`/admin/manage-admins/${id}`, payload);
        return response;
    } catch (error) {
        console.error('Update admin error:', error);
        throw error;
    }
};

export const getSingleAdmin = async (id) => {
    try {
        const response = await api.get(`/admin/manage-admins/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get admin error:', error);
    }
};

export const deleteAdmin = async (id) => {
    try {
        const response = await api.delete(`/admin/manage-admins/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete admin error:', error);
    }
};

export const updateAdminStatus = async (id, payload) => {
    try {
        const response = await api.patch(`/admin/manage-admins/${id}/status`, payload);
        return response;
    } catch (error) {
        console.error('Update admin status error:', error);
        throw error;
    }
};

export const forcePasswordResetAdmin = async (id) => {
    try {
        const response = await api.post(`/admin/manage-admins/${id}/force-password-reset`);
        return response;
    } catch (error) {
        console.error('Force password reset admin error:', error);
        throw error;
    }
};

export const getSingleHistoryAdmin = async (id, params) => {
    try {
        const response = await api.get(`/admin/manage-admins/${id}/history`, { params });
        return response.data;
    } catch (error) {
        console.error('Get admin history error:', error);
    }
};

export const getLoginHistoryAdmin = async (params) => {
    try {
        const response = await api.get(`/admin/manage-admins/history`, { params });
        return response.data;
    } catch (error) {
        console.error('Get admin history error:', error);
    }
};

export const getAppSettings = async () => {
    try {
        const response = await api.get(`/admin/settings`);
        return response.data;
    } catch (error) {
        console.error('Get app settings error:', error);
    }
};

export const updateAppSettings = async (payload) => {
    try {
        const response = await api.post(`/admin/settings`, payload);
        return response.data;
    } catch (error) {
        console.error('Update app settings error:', error);
        throw error;
    }
};